global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;



import AOS from 'aos';
import 'aos/dist/aos.css';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

$(document).ready(function() {

    // To-top button
    //const toTopBtn = $('#to-top');
    // toTopBtn.on('click', function (e) {
    //     e.preventDefault();
    //     $('html, body').animate({
    //         scrollTop: 1000,
    //     }, 'slow');
    // });

    // Button to prenota form
    var buttonToPrenota = $('.buttonToPrenota');

    window.addEventListener('resize', function (e) {
        modButtonPrenotaUrl();
    })

    modButtonPrenotaUrl();
    function modButtonPrenotaUrl() {
        let buttonUrl = buttonToPrenota.attr('href');

        if (window.innerWidth < 768) {
            if (!buttonUrl.includes('Desktop')){
                let newUrl = buttonUrl.replace('Desktop','')+'Desktop';
                buttonToPrenota.attr('href', newUrl);
            }

        } else {
            if (!buttonUrl.includes('Desktop')){
                let newUrl = buttonUrl.replace('Mobile','')+'Desktop';
                buttonToPrenota.attr('href', newUrl);
            }
        }
    }

    //show button to form
    if (window.innerWidth < 768){
        $(window).scroll(function(){
            if ($(window).scrollTop() > 800 && $(window).scrollTop() < 6400) {
                buttonToPrenota.addClass("buttonToPrenota--active");
            } else {
                buttonToPrenota.removeClass("buttonToPrenota--active");
            }
        });
    } else {
        $(window).scroll(function(){
            if ($(window).scrollTop() > 500 && $(window).scrollTop() < 3000) {
                buttonToPrenota.addClass("buttonToPrenota--active");
            } else {
                buttonToPrenota.removeClass("buttonToPrenota--active");
            }
        });
    }





    // AOS animations
    $(function() {
        AOS.init({
            duration: 600,
            //offset: 50,
            once: true,
        });
    });
});
